import { useState } from "react";
import { SliderHorizontalIcon } from "../utils/svg";
import i18n from "i18next";

function ModuleLeads() {
  const [backdropToggled, setBackdropToggled] = useState(true);
  let locale = i18n.language;

  const handleBackdropClick = (e) => {
    setBackdropToggled(false);
  };

  return (
    <div className="stat__table">
      {backdropToggled && (
        <>
          <div className="stat__table-icon">
            <SliderHorizontalIcon />
          </div>
          <div className="stat__table-backdrop" onClick={handleBackdropClick}></div>
        </>
      )}

      <div className="stat__table-data">
        <div className="stat__table-data-container">
          {locale !== "ru" ? (
            <table>
              <thead>
                <tr>
                  <th colSpan="3">Teaching Staff</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Nika Almar</td>
                  <td>Associate Professor</td>
                  <td>n.almar@siil.ch</td>
                </tr>
                <tr>
                  <td>Diana Arutyunyan</td>
                  <td>Lecturer</td>
                  <td>d.arutyunyan@siil.ch</td>
                </tr>
                <tr>
                  <td>Tatyana Belikova</td>
                  <td>Associate Professor</td>
                  <td>t.belikova@siil.ch</td>
                </tr>
                <tr>
                  <td>Sergei Bogachev</td>
                  <td>Professor</td>
                  <td>s.bogachev@siil.ch</td>
                </tr>
                <tr>
                  <td>Ivan Glazkov</td>
                  <td>Lecturer</td>
                  <td>i.glazkov@siil.ch</td>
                </tr>
                <tr>
                  <td>Andrey Ilyin</td>
                  <td>Professor</td>
                  <td>a.ilyin@siil.ch</td>
                </tr>
                <tr>
                  <td>Alexandra Kalgina</td>
                  <td>Associate Professor</td>
                  <td>a.kalgina@siil.ch</td>
                </tr>
                <tr>
                  <td>Anastasia Kashirina</td>
                  <td>Associate Professor</td>
                  <td>a.kashirina@siil.ch</td>
                </tr>
                <tr>
                  <td>Valentin Mingalev</td>
                  <td>Lecturer</td>
                  <td>v.mingalev@siil.ch</td>
                </tr>
                <tr>
                  <td>Alexander Pavlov</td>
                  <td>Lecturer</td>
                  <td>a.pavlov@siil.ch</td>
                </tr>
                <tr>
                  <td>Daria Rozhkova</td>
                  <td>Professor</td>
                  <td>d.rozhkova@siil.ch</td>
                </tr>
                <tr>
                  <td>Yury Ovseenko</td>
                  <td>Professor</td>
                  <td>y.ovseenko@siil.ch</td>
                </tr>
                <tr>
                  <td>Larisa Salieva</td>
                  <td>Lecturer</td>
                  <td>l.salieva@siil.ch</td>
                </tr>
                <tr>
                  <td>Yulia Sizova</td>
                  <td>Associate Professor</td>
                  <td>y.sizova@siil.ch</td>
                </tr>
                <tr>
                  <td>Anna Sosnovskaya</td>
                  <td>Lecturer</td>
                  <td>a.sosnovskaya@siil.ch</td>
                </tr>
                <tr>
                  <td>Pavel Tkachev</td>
                  <td>Professor</td>
                  <td>p.tkachev@siil.ch</td>
                </tr>
                <tr>
                  <td>Galina Tolkachenko</td>
                  <td>Professor</td>
                  <td>g.tolkachenko@siil.ch</td>
                </tr>
                <tr>
                  <td>Oksana Tolkachenko</td>
                  <td>Associate Professor</td>
                  <td>o.tolkachenko@siil.ch</td>
                </tr>
                <tr>
                  <td>Natalya Tsareva</td>
                  <td>Associate Professor</td>
                  <td>n.tsareva@siil.ch</td>
                </tr>
                <tr>
                  <td>Evgeny Vengerovskiy</td>
                  <td>Associate Professor</td>
                  <td>e.vengerovskiy@siil.ch</td>
                </tr>
                <tr>
                  <td>Andrey Vlasenko</td>
                  <td>Professor</td>
                  <td>a.vlasenko@siil.ch</td>
                </tr>
                <tr>
                  <td>Andrey Zaikov</td>
                  <td>Lecturer</td>
                  <td>a.zyikov@siil.ch</td>
                </tr>
                <tr>
                  <td>Polina Zakharova</td>
                  <td>Lecturer</td>
                  <td>p.zakharova@siil.ch</td>
                </tr>
                <tr>
                  <td>Nikolay Zubov</td>
                  <td>Professor</td>
                  <td>n.zubov@siil.ch</td>
                </tr>
                <tr>
                  <td>Tatiana Tangisheva</td>
                  <td>Associate Professor</td>
                  <td>t.tangisheva@siil.ch</td>
                </tr>
                <tr>
                  <td>Alexander Malyzhenkov</td>
                  <td>Associate Professor</td>
                  <td>a.malyzhenkov@siil.ch</td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table>
              <thead>
                <tr>
                  <th colSpan="3">Преподавательский состав</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Ника Алмар</td>
                  <td>Доцент</td>
                  <td>n.almar@siil.ch</td>
                </tr>
                <tr>
                  <td>Диана Арутюнян</td>
                  <td>Преподаватель</td>
                  <td>d.arutyunyan@siil.ch</td>
                </tr>
                <tr>
                  <td>Татьяна Беликова</td>
                  <td>Доцент</td>
                  <td>t.belikova@siil.ch</td>
                </tr>
                <tr>
                  <td>Сергей Богачев</td>
                  <td>Профессор</td>
                  <td>s.bogachev@siil.ch</td>
                </tr>
                <tr>
                  <td>Иван Глазков</td>
                  <td>Преподаватель</td>
                  <td>i.glazkov@siil.ch</td>
                </tr>
                <tr>
                  <td>Андрей Ильин</td>
                  <td>Профессор</td>
                  <td>a.ilyin@siil.ch</td>
                </tr>
                <tr>
                  <td>Александра Кальгина</td>
                  <td>Доцент</td>
                  <td>a.kalgina@siil.ch</td>
                </tr>
                <tr>
                  <td>Анастасия Каширина</td>
                  <td>Доцент</td>
                  <td>a.kashirina@siil.ch</td>
                </tr>
                <tr>
                  <td>Валентин Мингалёв</td>
                  <td>Преподаватель</td>
                  <td>v.mingalev@siil.ch</td>
                </tr>
                <tr>
                  <td>Александр Павлов</td>
                  <td>Преподаватель</td>
                  <td>a.pavlov@siil.ch</td>
                </tr>
                <tr>
                  <td>Дарья Рожкова</td>
                  <td>Профессор</td>
                  <td>d.rozhkova@siil.ch</td>
                </tr>
                <tr>
                  <td>Юрий Овсеенко</td>
                  <td>Профессор</td>
                  <td>y.ovseenko@siil.ch</td>
                </tr>
                <tr>
                  <td>Лариса Салиева</td>
                  <td>Преподаватель</td>
                  <td>l.salieva@siil.ch</td>
                </tr>
                <tr>
                  <td>Юлия Сизова</td>
                  <td>Доцент</td>
                  <td>y.sizova@siil.ch</td>
                </tr>
                <tr>
                  <td>Анна Сосновская</td>
                  <td>Преподаватель</td>
                  <td>a.sosnovskaya@siil.ch</td>
                </tr>
                <tr>
                  <td>Павел Ткачев</td>
                  <td>Профессор</td>
                  <td>p.tkachev@siil.ch</td>
                </tr>
                <tr>
                  <td>Галина Толкаченко</td>
                  <td>Профессор</td>
                  <td>g.tolkachenko@siil.ch</td>
                </tr>
                <tr>
                  <td>Оксана Толкаченко</td>
                  <td>Доцент</td>
                  <td>o.tolkachenko@siil.ch</td>
                </tr>
                <tr>
                  <td>Наталья Царёва</td>
                  <td>Доцент</td>
                  <td>n.tsareva@siil.ch</td>
                </tr>
                <tr>
                  <td>Венгеровский Евгений</td>
                  <td>Доцент</td>
                  <td>e.vengerovskiy@siil.ch</td>
                </tr>
                <tr>
                  <td>Андрей Власенко</td>
                  <td>Профессор</td>
                  <td>a.vlasenko@siil.ch</td>
                </tr>
                <tr>
                  <td>Андрей Зайков</td>
                  <td>Преподаватель</td>
                  <td>a.zyikov@siil.ch</td>
                </tr>
                <tr>
                  <td>Полина Захарова</td>
                  <td>Преподаватель</td>
                  <td>p.zakharova@siil.ch</td>
                </tr>
                <tr>
                  <td>Николай Зубов</td>
                  <td>Профессор</td>
                  <td>n.zubov@siil.ch</td>
                </tr>
                <tr>
                  <td>Татьяна Тангишева</td>
                  <td>Доцент</td>
                  <td>t.tangisheva@siil.ch</td>
                </tr>
                <tr>
                  <td>Александр Малыженков</td>
                  <td>Доцент</td>
                  <td>a.malyzhenkov@siil.ch</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModuleLeads;
